// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { gameController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { DialogSettings, MiscSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_btn_green, s_btn_orange, s_btn_blue, s_popup_close, s_icon_close } from "../AssetDefinitions/ImageDefinitions";
export var NewGameDialog = function (properties, onCancelCallback, onFriendCallback, onRandomCallback, onAICallback) {
    "use strict";
    this.name = "NewGameDialog"; // The name of the dialog
    // Initialize properties
    this.initialize();
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onCancelCallback = onCancelCallback;
    this.onFriendCallback = onFriendCallback;
    this.onRandomCallback = onRandomCallback;
    this.onAICallback = onAICallback;
};
// Inherit the base dialog
tgfDialogs.inherit(NewGameDialog, DialogBase);
NewGameDialog.prototype.doPrepare = function () {
    "use strict";
    var self = this;
    var i;
    this.transparentBlack = new ComponentPicture({
        x: -100,
        y: -100,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.bg = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: 800,
        height: 550,
        x: -(800 * 0.5),
        y: -270
    }, null);
    this.addComponent(this.bg);
    this.addComponent(new ComponentPicture({ image: s_popup_top, x: 0, y: -285 }));
    this.addComponent(new ComponentPicture({ image: s_popup_bottom, x: 0, y: -285 + 550 }));
    var titleLabel = new ComponentLabel({
        x: 0,
        y: -185,
        text: "Please select a game type to play",
        font: DialogSettings.textFont
    });
    this.addComponent(titleLabel);
    var btnPlayWithFriend = new ComponentButton({
        x: 0,
        y: -70,
        image: s_btn_green,
        onClick: function () {
            self.hide();
            self.onFriendCallback();
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
        }
    });
    btnPlayWithFriend.addComponent(new ComponentLabel({
        text: tgfDictionary.getText("BTN_FRIEND_MATCH"),
        font: DialogSettings.buttonFont
    }));
    this.addComponent(btnPlayWithFriend);
    var btnPlayRandom = new ComponentButton({
        x: 0,
        y: 55,
        image: s_btn_orange,
        onClick: function () {
            self.hide();
            self.onRandomCallback();
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
        }
    });
    btnPlayRandom.addComponent(new ComponentLabel({
        x: 0,
        y: 0,
        text: tgfDictionary.getText('BTN_QUICK_PLAY'),
        font: DialogSettings.buttonFont
    }));
    this.addComponent(btnPlayRandom);
    var btnPlayPractice = new ComponentButton({
        x: 0,
        y: 180,
        image: s_btn_blue,
        onClick: function () {
            self.hide();
            self.onAICallback();
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
        }
    });
    btnPlayPractice.addComponent(new ComponentLabel({
        x: 0,
        y: 0,
        text: tgfDictionary.getText('BTN_PRACTICE_MATCH'),
        font: DialogSettings.buttonFont
    }));
    this.addComponent(btnPlayPractice);
    var textHeading = new ComponentLabel({
        x: 0,
        y: -280,
        text: "NEW GAME",
        font: DialogSettings.headingFont
    });
    this.addComponent(textHeading);
    var closeButton = new ComponentButton({
        image: s_popup_close,
        icon: s_icon_close,
        iconPosition: "center",
        x: 415,
        y: -250,
        touchMargin: MiscSettings.closeButtonTouchMargin,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
            gameController.closeNewGameDialogs();
            self.onCancelCallback();
        }
    });
    this.addComponent(closeButton);
};
